import configAxios from 'axios';

const apiInstance = configAxios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        "Content-type": "application/x-www-form-urlencoded"
    }
});

apiInstance.interceptors.request.use(requisicao => {
    const data = requisicao.data ?? {};
    const params = requisicao.params ?? {};

    if (!params.b) {
        data.token = process.env.VUE_APP_GLOBAL_TOKEN;
    }

    requisicao.data = data;

    return requisicao;
});

export default apiInstance;
